import { SET_CUSTOM_CONNECTORS_META_DATA } from "./types";

export const customConnectorsReducer = (state = {}, action) => {
  if (action.type === SET_CUSTOM_CONNECTORS_META_DATA) {
    return { ...state, metaData: action.payload };
  }
  return state;
};